import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import axios from 'axios';
import { Button } from '../../Button/button';
import './TabContent.css';
import AlertPopup from './AlertPopup';

const ProfileTab = ({ userDetails, onUserUpdate }) => {
    const [alert, setAlert] = useState({ message: '', type: 'info' });

    if (!userDetails) {
        return (
            <div className="loaderContainer">
                <div className="loader"></div>
            </div>
        );
    }

    return (
        <>
            <AlertPopup
                message={alert.message}
                type={alert.type}
                onClose={() => setAlert({ message: '', type: 'info' })}
            />
            <div className="tab-content">
                <div className="tab-header">
                    <h2>Profile Information</h2>
                    <p>Update your personal information and bio</p>
                </div>

                <Formik
                    enableReinitialize
                    initialValues={userDetails}
                    onSubmit={(values) => {
                        const payload = {
                            id: values.id,
                            firstname: values.firstname,
                            lastname: values.lastname,
                            email: values.email,
                            phone: values.phone,
                            description: values.bio,
                            services: values.services
                        };

                        axios.put(`${process.env.REACT_APP_API_BASE_URL}/users/${values.id}`, payload)
                            .then((res) => {
                                setAlert({
                                    message: 'Profile updated successfully!',
                                    type: 'success'
                                });
                                if (onUserUpdate) {
                                    onUserUpdate({
                                        ...userDetails,
                                        ...payload,
                                        bio: payload.description // ensure local state bio is updated
                                    });
                                }
                            })
                            .catch((err) => {
                                console.error(err);
                                setAlert({
                                    message: 'Failed to update profile. Please try again.',
                                    type: 'error'
                                });
                            });
                    }}
                >
                    {({ values }) => (
                        <Form className="form-box">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label">First Name</label>
                                    <Field name="firstname" className="form-control" placeholder="First Name" />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Last Name</label>
                                    <Field name="lastname" className="form-control" placeholder="Last Name" />
                                </div>
                            </div>

                            <div className="row g-3 mt-3">
                                <div className="col-md-6">
                                    <label className="form-label">Email</label>
                                    <Field name="email" type="email" className="form-control" placeholder="Email" disabled />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Phone</label>
                                    <Field name="phone" className="form-control" placeholder="Phone" />
                                </div>
                            </div>

                            {/* Only show bio for healers */}
                            {userDetails.role === 'healer' && (
                                <div className="row g-3 mt-3">
                                    <div className="col-12">
                                        <label className="form-label">Bio*</label>
                                        <Field as="textarea" name="bio" className="form-control" placeholder="Tell us about yourself..." maxLength="200" rows="4" />
                                        <div className="char-count">{(values.bio || '').length}/200</div>
                                    </div>
                                </div>
                            )}

                            <div className="d-flex justify-content-end gap-3 mt-4">
                                <Button type="button" buttonStyle="btn--secondary">Cancel</Button>
                                <Button type="submit" buttonStyle="btn--primary">Save changes</Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    );
};

export default ProfileTab; 